import React from 'react';
import { useQueryClient } from 'react-query';
import { Modal, Form } from 'antd';
import OwnersSelectField from '../../formComponents/OwnersSelectField';
import { validationRules } from '../constants';
import useAddRoomOwnersMutation from '../../../mutations/useAddRoomOwnersMutation';
import { roomQueryKeys } from '../../../queries/queryKeys';
import { getEditingRoomData } from '../../../utils/getEditingRoomData';

const AddRoomOwners = ({ form, onCancel, visible, room }) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const queryClient = useQueryClient();

  const { mutateAsync: addOwnersMutateAsync, isLoading: isAddOwnersLoading } =
    useAddRoomOwnersMutation({
      onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
    });

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const data = getEditingRoomData(room);

        const existingOwnerIds = Boolean(room?.landLords?.length)
          ? room.landLords.map((landLord) => landLord.id)
          : [];

        const owners = Array.from(
          new Set(
            values.landLordKeys
              .filter((key) => Boolean(values[`landLord-${key}`]))
              .map((key) => values[`landLord-${key}`])
              .concat(existingOwnerIds)
          )
        ).map((id) => ({ id }));

        await addOwnersMutateAsync({ room: data, owners });
        handleCancel();
      }
    });
  };

  return (
    <Modal
      visible={visible}
      title="Добавить собственника"
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Добавить"
      confirmLoading={isAddOwnersLoading}
      destroyOnClose
    >
      <Form id="addRoomOwnersForm">
        <OwnersSelectField
          form={form}
          hasLabel={false}
          getPopupContainer={() => document.getElementById('addRoomOwnersForm')}
          options={{
            rules: [
              validationRules.required('Выберите собственника', 'number'),
            ],
          }}
        />
      </Form>
    </Modal>
  );
};

const AddRoomOwnersModal = Form.create({ name: 'add_room_owners' })(
  AddRoomOwners
);

export default AddRoomOwnersModal;
